module.exports = __webpack_public_path__ + "fonts/5c7d08214fe263d92dcb83cf698f5ad4-SocialBrands-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SocialBrands-Regular.woff2
// module id = 357
// module chunks = 0